/**
 * Нормализация величин к диапазону 0..1.
 *
 * Приоритет складывается из разнородных величин: долей, миллисекунд и рангов.
 * Без приведения к общей шкале веса формулы теряют смысл.
 */

/** Ограничивает значение отрезком [0, 1]. */
export function clamp01(value: number): number {
  if (Number.isNaN(value)) return 0;
  return Math.min(1, Math.max(0, value));
}

/** Линейно отображает значение из [min, max] в [0, 1]. */
export function normalizeRange(value: number, min: number, max: number): number {
  if (max <= min) return 0;
  return clamp01((value - min) / (max - min));
}

/**
 * Логарифмическое сглаживание относительного роста.
 *
 * Нужно, чтобы искусственно низкий baseline не давал огромного преимущества
 * в рейтинге (ТЗ FR-LB-04).
 */
export function smoothGrowth(ratio: number, cap: number): number {
  if (ratio <= 1) return 0;
  return clamp01(Math.log(ratio) / Math.log(cap));
}
